import * as React from 'react';

// PACKAGES
import { Link } from 'react-router-dom';

// COMPONENTS
import CircleImage from '../../components/CircleImage';
import DisplayDateTime from '../../components/DisplayDateTime';
import DisplayTimeFromNow from '../../components/DisplayTimeFromNow';

interface RequestsToJoinItemTypes {
	id?: string;
	firstName?: string;
	lastName?: string;
	image?: string;
	organisationRole?: string[];
	timeRequested?: string;
	role: string;
}
import { ExtraDomainProfileType } from '../../Interfaces';
import { DomainProfileType } from '../../api/models';

const RequestsToJoinItem: React.FC<RequestsToJoinItemTypes> = ({
	id,
	firstName,
	lastName,
	image,
	timeRequested,
	role
}) => {
	return (
		<div className="info-section mtop-0" key={id}>
			<div className="row-container">
				<div className="row detail-row">
					<div className="col-auto pdl-0 pdr-0">
						<CircleImage src={image} size={40} firstName={firstName} lastName={lastName} />
					</div>

					<div className="col-md-auto full-width">
						<div className="row detail-info">
							<div className="col-md-3 detail-name">
								{firstName} {lastName}
							</div>
							
							<div className="col-md-6 detail-status ">
								<div className="title">Date Requested</div>

								<time className="time">
									<DisplayDateTime>{timeRequested}</DisplayDateTime>
								</time>
							</div>

							<div className="col-md-3 detail-status">
								<time className="time mr-0 request-to-join-page">
									<DisplayTimeFromNow>{timeRequested}</DisplayTimeFromNow>
								</time>
							</div>
						</div>
					</div>

					<div className="col-auto pdr-0 link-group request-to-join-page">
						<Link
							className="btn-text pdr-0"
							to={{
								pathname: `/requests-to-join/${id}`,
								state: {
									isStaff:
										role === DomainProfileType.Staff || role === DomainProfileType.SuperAdministrator ? true : false,
									volunteer: role === ExtraDomainProfileType.ParentVolunteer ? true : false
								}
							}}
						>
							View
						</Link>
					</div>
				</div>
			</div>
		</div>
	);
};

export default RequestsToJoinItem;
